module.exports = __webpack_public_path__ + "static/media/AC.14cb1cd2.svg";